module.exports = __webpack_public_path__ + "static/media/day08.d887b0bc.jpg";